export default __webpack_public_path__ + "static/media/communicator.f2a83bcb.svg";